function getBackendServerUrl() {
  if (typeof window == 'undefined') {
    return `${process.env.BACKEND_SERVER_PROTOCOL}://${process.env.BACKEND_HOST_FOR_SERVER}`;
  }
  return `${process.env.BACKEND_SERVER_PROTOCOL}://${process.env.BACKEND_HOST_FOR_CLIENT}`;
}
const BRAND = {
  tennisi: 'tennisi',
  chesnok: 'chesnok'
};
const CONFIGS_URLS = {
  MATCH_GRID: 'site/presentation/matchgrid.json',
  STAKES_NAMES: 'site/presentation/templates.json'
};
const CLEAR_GLOBAL_CONFIGS_EMIT = 'clear-global-configs-cache';
module.exports = {
  BRAND,
  CLEAR_GLOBAL_CONFIGS_EMIT,
  CONFIGS_URLS,
  getBackendServerUrl
};